import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
type BadgeVariant = 'accent' | 'error' | 'info' | 'neutral' | 'success' | 'warning';
type KVItem = {
  key: string;
  value: string;
  badge?: {
    label: string;
    variant?: BadgeVariant;
  };
};
type KVListProps = {
  title?: string;
  items: KVItem[];
};
const BADGE_COLOR: Record<BadgeVariant, string> = {
  error: 'text-error',
  warning: 'text-warning',
  success: 'text-success',
  info: 'text-info',
  accent: 'text-accent',
  neutral: 'text-tertiary'
};
const KVList = t0 => {
  const $ = _c(11);
  const {
    title,
    items: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const items = t2;
  let t3;
  if ($[2] !== title) {
    t3 = title && <span className="text-label-2 text-primary fp-text">{title}</span>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== items) {
    t4 = items.map(_temp);
    $[4] = items;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <dl className="grid grid-cols-1 gap-1">{t4}</dl>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <div className="flex flex-col gap-3 w-full">{t3}{t5}</div>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default KVList;
function _temp(t0, i) {
  const {
    key,
    value,
    badge
  } = t0;
  const badgeLabel = badge?.label && badge.label.toLowerCase() !== value?.toLowerCase() ? badge.label : undefined;
  return <div key={`${key}-${i}`} className="flex items-start justify-between gap-4 min-h-6"><dt className="text-body-2 text-tertiary fp-text flex-none max-w-[45%] break-words md:max-w-none">{key}</dt><dd className="flex-1 min-w-0 break-words text-right md:min-w-auto"><span className="text-body-2 text-primary fp-text">{value || badge?.label || ""}</span>{value && badgeLabel && <span className={cx("text-body-2 fp-text", BADGE_COLOR[badge?.variant ?? "neutral"])}>{` · ${badgeLabel}`}</span>}</dd></div>;
}